import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getPayRoll = createAsyncThunk("api/atm-payroll/payroll", async (token) => {
    try {
        const response = await nodeinstance.get("/atm-payroll/payroll/", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const PayRollDataSlice = createSlice({
    name: "boder",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPayRoll.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getPayRoll.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getPayRoll.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getPayRoll };
export default PayRollDataSlice.reducer;
